import React from 'react';
import EvCharger from './EvCharger';
import Icon from '../icon';
import Circuit from './Circuit';
import {NodeTypes} from '../../../../constants/nodeTypes';

const RenderForeignObjectNode = ({nodeDatum, foreignObjectProps, addNode}) => {
  const nodeClicked = () => {
    console.log('the node has been clicked', nodeDatum);
  };

  switch (nodeDatum.type) {
    case NodeTypes.ADDNODE:
      return (
        <g onClick={() => addNode(nodeDatum)}>
          <circle transform="translate(20, 0)" r={10} stroke="none" fill="transparent"/>
          <g transform="translate(-5,-25)">
            <Icon name="add" color={'var(--blue)'} size={50}/>
          </g>
        </g>
      );
    case NodeTypes.EVCHARGER:
      return (
        <g>
          <circle r={5} onClick={nodeClicked} stroke="none" fill="#4590d1"/>
          <foreignObject style={{overflow: 'visible'}} transform="translate(-120, -60)" {...foreignObjectProps}>
            <EvCharger nodeDatum={nodeDatum}/>
          </foreignObject>
        </g>
      );
    case NodeTypes.CIRCUIT:
      return (
        <g>
          <circle r={10} onClick={nodeClicked} fill="white"/>
          <foreignObject style={{overflow: 'visible'}} transform="translate(-120, -180)" {...foreignObjectProps}>
            <Circuit nodeDatum={nodeDatum}/>
          </foreignObject>
        </g>
      );
    default:
      return null;
  }
};

export default RenderForeignObjectNode;

